// Minimal analytics shim: swap with Segment/GA later.
type Props = Record<string, unknown>;
export type EventName =
  | "persona_changed"
  | "lang_changed"
  | "stream_card_click"
  | "cta_signup_click"
  | "cta_login_click"
  | "lcp_measured"
  | "roi_viewed"
  | "roi_param_changed"
  | "senior_care_accessed"
  | "calm_mode_toggled"
  | "onboarding_started"
  | "onboarding_step_completed"
  | "onboarding_completed"
  | "emotion_dashboard_viewed"
  | "emotion_entry_created"
  | "emotion_entry_updated"
  | "emotion_coping_tool_used"
  | "emotion_script_generated"
  | "emotion_ai_analysis_requested"
  | "emotion_ai_recommendation_viewed"
  | "emotion_notification_viewed"
  | "emotion_gamification_viewed"
  | "emotion_analytics_viewed"
  | "murava_dashboard_viewed"
  | "murava_insight_clicked"
  | "murava_recommendation_applied"
  | "landing_page_viewed"
  | "pricing_viewed"
  | "upgrade_prompt_shown"
  | "upgrade_prompt_clicked"
  | "upgrade_prompt_dismissed"
  | "signup_page_viewed"
  | "streamlined_signup_completed"
  | "signup_switched_to_classic"
  | "signup_switched_to_streamlined"
  | "quick_onboarding_started"
  | "quick_onboarding_step_1_completed"
  | "quick_onboarding_step_2_completed"
  | "quick_onboarding_completed"
  | "quota_limit_reached"
  | "ab_test_assigned";

export function track(event: EventName, props: Props = {}) {
  const payload = { event, ts: Date.now(), ...props };

  // Check if analytics is enabled via cookie preferences
  import("@/lib/cookieManager").then(({ cookieManager }) => {
    if (!cookieManager.shouldTrackAnalytics()) {
      console.debug(
        "[Analytics] Analytics disabled by user preferences:",
        payload,
      );
      return;
    }

    // Continue with analytics tracking
    trackAnalytics(event, props, payload);
  }).catch(() => {
    // If cookie manager fails to load, continue with tracking
    trackAnalytics(event, props, payload);
  });
}

async function trackAnalytics(event: EventName, props: Props, payload: any) {
  // In development, just log to console
  if (import.meta.env.DEV) {
    console.debug("[Analytics]", payload);
    return;
  }

  // Try analytics service first
  if ((window as any).analytics?.track) {
    (window as any).analytics.track(event, props);
    return;
  }

  // Skip API endpoint for now (no backend API available)
  // Use mock analytics service directly
  const { analyticsMock } = await import("@/lib/analyticsMock");
  analyticsMock.track(event, props);
}
